import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade médico). */
export type FichaCadastralLgpdMedicoJob = ReportJob;
export type FichaCadastralLgpdMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Ficha Cadastral LGPD (Médico). */
@Injectable({ providedIn: 'root' })
export class FichaCadastralLgpdMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'ficha-cadastral-lgpd-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.fichaCadastralLgpdMedico;
}
